<template>
<div>
	<div class="container" v-if="widthMax > 768">
		<div class="row my-4">
			<div class="col-12 ">
				<router-link to="/review-list" class="text-dark">
					Mentor lists
				</router-link> > <span class="text-blue-sky">Review detail</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 border rounded mb-3 px-4 py-4" >
				<div class="row">
					<div class="col-md-2 text-center">
						<div class="box-img-m mb-3 mx-auto" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''">
							<img class="mw-100" :src="proFilePic+val.detailUser[0].profilePic">
						</div>
						<div class="box-img-m mb-3 mx-auto" v-else>
							<img class="mw-100" src="@/assets/user.png">
						</div>
						<div class="mb-3" v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'">
							<strong>Price&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly +'/hour'}}</strong>
						</div>
						<button class="btn-review" data-toggle="modal" data-target="#reviewModal" @click="selectMentor(val)">
							Review
						</button>
					</div>
					<div class="col-md-10">
						<div class="row">
							<div class="col-12">
								<h4 class="font-20 text-capitalize">{{ val.detailUser[0].name  }} {{ val.detailUser[0].surname  }} 
									<span class="font-14">Rating <span v-for="(value,key) in 5"  class="mr-2" :key="key">
										<i class="fas fa-star" :class="review.rating >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>
									({{review.rating | floatNumber}})
									</span>
								</h4>
							</div>
						</div>
						<div class="row color-grey-dark">
							<div class="col-12" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">
								"{{val.detailUser[0].professionTitle}}"
							</div>
							<div class="col-12" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
					             Living in: <span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">{{ val.detailUser[0].living }}</span>
					          </div>
							<div class="col-12 my-3" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0">
								Talk well in: <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage">{{ `${data.name}` }}<span v-if=" val.detailUser[0].language.length-1 > indexlangage">, </span></span>
							</div>
							<div class="col-12 my-2">
								<nav class="level is-mobile">
							      <div class="level-left d-flex" >
							        <a title="facebook"  target="_blank" :href="'https://www.facebook.com'" class="level-item mr-2">
							            <div class="circle-social">
							            <i class="fab fa-facebook-f"></i>
							            </div>
							        </a>
							        <a title="linkedin" v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.linkedin" class="level-item mr-2">
							          <div class="circle-social">
							            <i class="fab fa-linkedin-in"></i>
							          </div>
							        </a>
							          <a title="line" v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.line" class="level-item mr-2">
							             <div class="circle-social">
							            <i class="fab fa-line"></i>
							            </div>
							        </a>
							        <a title="skype" v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.skype" class="level-item mr-2">
							             <div class="circle-social">
							            <i class="fab fa-skype"></i>
							            </div>
							        </a>
							        <a title="hangout" v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.hangouts" class="level-item mr-2">
							             <div class="circle-social">
							            <span>H</span> 
							            </div>
							        </a>
							         <a title="zoom" v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.zoom" class="level-item mr-2">
							             <div class="circle-social">
							             <span>Z</span>
							            </div>
							        </a>
							      </div>
							    </nav>
							</div>	
							<div class="col-12">
								<hr>
							</div>
							<div class="col-12" v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
								<div>{{val.detailUser[0].aboutMe}}</div>
							</div>
							<div class="col-12 mt-4">
								<div class="bg-grey rounded py-2 px-3 mr-3 mb-3 d-inline-block" v-for="(data,indexOfdetailUser) in val.detailUser[0].industryExpertise" :key="indexOfdetailUser">
									{{data.name}}
								</div>
							</div>
						</div>	
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="review.review.length > 0">
			<div class="col-12 border rounded mb-3 px-4 py-4">
				<div class="row mb-3">
					<div class="col-6">
						<h5>Reviews</h5>
					</div>
					<div class="col-6 d-flex justify-content-end align-items-center sort-by ">
						Sort by
				
							<select class="ml-2 border-raduis-30 hide-action-bt" v-model="sortDec" @change="sortNumber()">
								<option value="1">Highest overall rating</option>
								<option value="2">Lowest overall rating</option>
								<option value="3">Date</option>
							</select>	
				
					</div>
				</div>
				<div class="row mb-3" v-for="(data,index) in review.review" :key="index">
					<div class="col-2 text-center">
						<div class="box-img-m mb-3 mx-auto bg-light" v-if="data.anonymous == true || data.reviewPic == ''">
							<img class="mw-100" src="@/assets/user.png">
						</div>
						<div v-else class="box-img-m mb-3 mx-auto bg-light">
							<img class="mw-100" :src="getProfilePic(data.typeSystem)+data.reviewPic" >
						</div>
					</div>
					<div class="col-8 color-grey-dark">

						<div>
							<b>Rate </b> <span v-for="(value,key) in 5" :key="key"  class="mr-2"><i class="fas fa-star" :class="data.rating >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>
						</div>
						<div>
							<p class="font-weight-bold text-back my-2">{{data.title}}</p>
						</div>
						<div>
							{{data.detail}}
						</div>
						<div>
							<p class="font-weight-bold font-16 mt-2 text-back"><i>Review by 
								<span class="font-weight-normal">
									<span v-if="data.anonymous">anonymous</span>
									<span v-else>{{data.name}} {{data.surname}}</span>
									<span v-if="typeof data.createDate != 'null' && data.createDate != ''">
										({{covertime(data.createDate)}})
									</span>
								</span>
								</i>
							</p>
						</div>
					</div>
					<div class="col-12">
						<hr>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade bd-example-modal-lg" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  	<div class="modal-body">
                        <h3 class="text-center">Review</h3>
                        <div class="form-group">
                        	<label>
                            	<b>Mentor </b><span>{{dataReview.reviewToName}}</span>
                        	</label>    
                        </div>
                        <div class="form-group">
                        	<label>
                           		<b>Title</b> 
                        	</label>    
                           	<div>
                        		<input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                           	</div>
                        </div>
                        <div class="form-group">
                           	<label>
                               	<b>Detail</b>
                           	</label>    
                           	<div>
                             	<textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                        	</div>
                        </div>
                        <div class="form-group">
							<b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" :key="index" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
							<p class="text-danger" v-if="validateRate == true">Please rate mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                        	<div class="col-6 mx-auto">
                        		<button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                        		<button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                        	</div>
	                    </div>
                  	</div>
                </div>
            </div>
        </div>	
	</div>
	<div class="container" v-else>
		<div class="row my-4">
			<div class="col-12 ">
				<router-link to="/review-list" class="text-dark">
					mentors
				</router-link> > <span class="text-blue-sky">Review detail</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 border rounded mb-3 px-4 py-4" >
				<div class="row">
					<div class="col-md-2 text-center">
						<div class="box-img-m mb-3 mx-auto" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''">
							<img class="mw-100" :src="proFilePic+val.detailUser[0].profilePic">
						</div>
						<div class="box-img-m mb-3 mx-auto" v-else>
							<img class="mw-100" src="@/assets/user.png">
						</div>
						<div class="mb-3" v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'">
							<strong>Price&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly +'/hour'}}</strong>
						</div>
						<button class="btn-review" data-toggle="modal" data-target="#reviewModal" @click="selectMentor(val)">
							Review
						</button>
					</div>
					<div class="col-md-10 mt-3">
						<div class="row text-center">
							<div class="col-12">
								<h4 class="font-20">{{ val.detailUser[0].name  }} {{ val.detailUser[0].surname  }} </h4>
								<div>
									<h4 class="font-20">
									<span class="font-14">Rating <span v-for="(value,key) in 5"  class="mr-2" :key="key">
										<i class="fas fa-star" :class="review.rating >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>
									({{review.rating | floatNumber}})
									</span>
									</h4>
								</div>
							</div>
						</div>
						<div class="row color-grey-dark">
							<div class="col-12" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">(Profession title) {{val.detailUser[0].professionTitle}}
							</div>
							<div class="col-12 my-3" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
					            <strong> Living in : </strong><span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">{{ val.detailUser[0].living }}</span>
					          </div>
							<div class="col-12 my-3" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0">
								<strong>Talk well in :</strong> <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage"> {{ `${data.name}` }}<span v-if=" val.detailUser[0].language.length-1 > indexlangage">,</span>  </span>
							</div>
							<div class="col-12 my-2">
								<nav class="level is-mobile">
							      <div class="level-left d-flex" >
							        <a title="facebook"  target="_blank" :href="'https://www.facebook.com'" class="level-item mr-2">
							            <div class="circle-social">
							            <i class="fab fa-facebook-f"></i>
							            </div>
							        </a>
							        <a title="linkedin" v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.linkedin" class="level-item mr-2">
							          <div class="circle-social">
							            <i class="fab fa-linkedin-in"></i>
							          </div>
							        </a>
							          <a title="line" v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.line" class="level-item mr-2">
							             <div class="circle-social">
							            <i class="fab fa-line"></i>
							            </div>
							        </a>
							        <a title="skype" v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.skype" class="level-item mr-2">
							             <div class="circle-social">
							            <i class="fab fa-skype"></i>
							            </div>
							        </a>
							        <a title="hangout" v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.hangouts" class="level-item mr-2">
							             <div class="circle-social">
							            <span>H</span> 
							            </div>
							        </a>
							         <a title="zoom" v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  target="_blank" :href="'https://'+val.detailUser[0].social.zoom" class="level-item mr-2">
							             <div class="circle-social">
							             <span>Z</span>
							            </div>
							        </a>
							      </div>
							    </nav>
							</div>	
							<div class="col-12">
								<hr>
							</div>
							<div class="col-12 text-justify" v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
								<div>{{val.detailUser[0].aboutMe}}</div>
							</div>
							<div class="col-12 mt-4">
								<div class="bg-grey rounded py-2 px-3 mr-3 mb-3 d-inline-block" v-for="(data,indexOfdetailUser) in val.detailUser[0].industryExpertise" :key="indexOfdetailUser">
									{{data.name}}
								</div>
							</div>
						</div>	
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="review.review.length > 0">
			<div class="col-12 border rounded mb-3 px-4 py-4">
				<div class="row mb-3">
					<div class="col-12 text-center">
						<h5>Reviews</h5>
					</div>
					<div class="col-12 d-flex justify-content-center align-items-center sort-by ">
						Sort by
				
							<select class="ml-2 border-raduis-30 hide-action-bt" v-model="sortDec" @change="sortNumber()">
								<option value="1">Highest overall rating</option>
								<option value="2">Lowest overall rating</option>
								<option value="3">Date</option>
							</select>	
					</div>
				</div>
				<div class="row mb-3" v-for="(data,index) in review.review" :key="index">

					<div class="col-12 color-grey-dark">
						<div class="text-center">
							<div class="col-12 ">
								<div class="box-img-m mb-3 mx-auto bg-light" v-if="data.anonymous == true || data.reviewPic == ''">
									<img class="mw-100" src="@/assets/user.png" style='position: absolute;top: 20%;'>
								</div>
								<div v-else class="box-img-m mb-3 mx-auto bg-light">
									<img class="mw-100" :src="getProfilePic(data.typeSystem)+data.reviewPic" >
								</div>
							</div>
							<b>Rate </b> <span v-for="(value,key) in 5" :key="key"  class="mr-2"><i class="fas fa-star" :class="data.rating >= (key+1) ? 'text-orange' : 'text-muted'"></i></span>
						</div>
						<div>
							<p class="font-weight-bold text-back my-2">{{data.title}}</p>
						</div>
						<div class="text-justify">
							{{data.detail}}
						</div>
						<div>
							<p class="font-weight-bold font-16 mt-2 text-back"><i>Review by 
								<span class="font-weight-normal">
									<span v-if="data.anonymous">anonymous</span>
									<span v-else>{{data.name}} {{data.surname}}</span>
									<span v-if="typeof data.createDate != 'null' && data.createDate != ''">
										({{covertime(data.createDate)}})
									</span>
								</span>
								</i>
							</p>
						</div>
					</div>
					<div class="col-12">
						<hr>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade bd-example-modal-lg" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  	<div class="modal-body">
                        <h3 class="text-center">Review</h3>
                        <div class="form-group">
                        	<label>
                            	<b>Mentor </b><span>{{dataReview.reviewToName}}</span>
                        	</label>    
                        </div>
                        <div class="form-group">
                        	<label>
                           		<b>Title</b> 
                        	</label>    
                           	<div>
                        		<input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                           	</div>
                        </div>
                        <div class="form-group">
                           	<label>
                               	<b>Detail</b>
                           	</label>    
                           	<div>
                             	<textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                        	</div>
                        </div>
                        <div class="form-group">
							<b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" :key="index" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
							<p class="text-danger" v-if="validateRate == true">Please rate mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                        	<div class="col-6 mx-auto">
                        		<button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                        		<button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                        	</div>
	                    </div>
                  	</div>
                </div>
            </div>
        </div>	
	</div>
</div>
</template>
<script>
import moment from "moment";
import {HTTPReview,HTTPTicket,HTTPMentor} from '@/axios.js'
	export default{
		data(){
			return{
				widthMax:window.innerWidth,
				validateRate:false,
				imgPath:'',
				review:'',
				sortDec:3,
				proFilePic:process.env.VUE_APP_IMG_PROFILE,
				dataReview:{
					ticket:'',
					reviewTo:'',
					typeSystem:'',
					reviewToName:'',
					review:{
						reviewExport:'',
						ticket:'',
						category:'',
						title:'',
						detail:'',
						rating:0,
						reviewBy:'',
						reviewByName:'',
						reviewBySurname:'',
						anonymous:false,
					}
				},
		
			}
		},
		methods:{
			submitReview(){
				if(this.dataReview.review.rating == 0){
		          this.validateRate = true
		        }else{
	          		console.log('submitReview',this.setMentorList)
	          		let dataMentor = this.setMentorList.filter(search =>{
	          			return search.userId == this.dataReview.reviewTo
					})
					console.log('this.dataReview',this.dataReview)
	          		this.$store.commit('setMentorDetail',dataMentor[0])
	          		HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
	          		HTTPReview.post('/api/create/review',this.dataReview).then(res=>{
	          			console.log('/api/create/review',res)
						this.fetchComment();
						this.dataReview.review.detail = ''
						this.dataReview.review.rating = 0
						this.dataReview.review.title = ''
						this.dataReview.review.anonymous = false

	          		})
	          	}
      		},
			selectMentor(value){
				console.log('asdsad',value)
				if(typeof value.detailUser[0].name != 'undefined' && typeof value.detailUser[0].surname != 'undefined'){
					this.dataReview.reviewToName = value.detailUser[0].name+' '+value.detailUser[0].surname
				}
				this.dataReview.reviewTo = value.userId
			},
			sortNumber(){
		  		this.review.review.sort((a, b) => {
		  			if(this.sortDec == 1){
		  				const modifier = -1;
					    if (Number(a.rating) < Number(b.rating)) return -1 * modifier;
					    if (Number(a.rating) > Number(b.rating)) return 1 * modifier;
					    return 0;
		  			}else if(this.sortDec == 2){
						const modifier = 1;
					    if (Number(a.rating) < Number(b.rating)) return -1 * modifier;
					    if (Number(a.rating) > Number(b.rating)) return 1 * modifier;
					    return 0;
		  			}else{
		  				const modifier = -1;
					    if (a.createDate < b.createDate) return -1 * modifier;
					    if (a.createDate > b.createDate) return 1 * modifier;
					    return 0;
		  			}
			    });
			  },
			currencySymbol(val){
              let data = this.currency.filter(search =>{
                return search.code == val
              })
              return data[0].symbol
          	},
          	getProfilePic(type){
		        let path = ''
		        if(type == 'mentor'){
		          path = process.env.VUE_APP_IMG_PROFILE_MENTOR
		        }else if(type == 'inteGreat'){
		          path = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
		        }else if(this.user.typeSystem == 'ticket'){
			      path = process.env.VUE_APP_IMG_PROFILE_TICKET
			    }
			    console.log('getProfilePic',path)
		        return path
		      },
			fetchComment(){
				console.log(';;;;',this.val.userId)
				let data = {
					ticket:"",
					reviewTo:this.val.userId
				}
				HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
				HTTPReview.post('/api/get/review',data).then(res =>{
					console.log('/api/get/review',res)
					res.data.obj.review.sort((a, b) => {
		  				const modifier = -1;
					    if (a.createDate < b.createDate) return -1 * modifier;
					    if (a.createDate > b.createDate) return 1 * modifier;
					    return 0;
			    });
					this.review = res.data.obj

				})	
			},
			covertime(value){
		        if (value) {
		            var t = moment(value).format("DD MMMM YYYY h:mm a")
		            return t;
		         }
		    },
		},
		created(){
			this.fetchComment();
			this.dataReview.review.typeSystem = this.user.typeSystem
			this.dataReview.review.reviewBy = this.user.userId
			this.dataReview.review.reviewByName = this.user.name
			this.dataReview.review.reviewBySurname = this.user.surname
			this.dataReview.review.reviewExport = this.user.userExport	
		},
		computed:{
			currency(){
	            return this.$store.state.currency
	        },
			user(){
				return this.$store.state.user
			},
			val(){
				return this.$store.state.mentorDetail
				console.log('this.$store.state.mentorDetail',this.$store.state.mentorDetail)
			},
			setMentorList(){
				return this.$store.state.menTorList
			}
		}
	}
</script>